export const CREATE_PAGE_OR_TEMPLATE_MODAL_NAME = 'CREATE_PAGE_OR_TEMPLATE';
export const CREATE_PAGE_FROM_TEMPLATE_MODAL_NAME = 'CREATE_PAGE_FROM_TEMPLATE_MODAL_NAME';
export const LINK_CREATOR_MODAL_NAME = 'LINK_CREATOR_MODAL_NAME';
export const FOLDER_MANAGER_MODAL_NAME = 'FOLDER_MANAGER';
export const LINK_DETAILS_MODAL_NAME = 'LINK_DETAILS';
export const LINK_SHARER_MODAL_NAME = 'LINK_SHARER';
export const PAGE_DETAILS_MODAL_NAME = 'PAGE_DETAILS';
export const PAGE_DELETER_MODAL_NAME = 'PAGE_DELETER';
export const PAGE_REDIRECTOR_MODAL_NAME = 'PAGE_REDIRECTOR';
export const ROUTE_DELETER_MODAL_NAME = 'ROUTE_DELETER';
export const TEMPLATE_DETAILS_MODAL_NAME = 'TEMPLATE_DETAILS';
export const SITE_DEACTIVATOR_MODAL_NAME = 'SITE_DEACTIVATOR_MODAL_NAME';
export const EXPORT_SITE_MODAL_NAME = 'EXPORT_SITE_MODAL_NAME';
export const SITE_PREVIEW_COLLABORATION_MODAL_NAME = 'SITE_PREVIEW_COLLABORATION_MODAL_NAME';

export default [
  CREATE_PAGE_OR_TEMPLATE_MODAL_NAME,
  CREATE_PAGE_FROM_TEMPLATE_MODAL_NAME,
  LINK_CREATOR_MODAL_NAME,
  FOLDER_MANAGER_MODAL_NAME,
  LINK_DETAILS_MODAL_NAME,
  LINK_SHARER_MODAL_NAME,
  PAGE_DETAILS_MODAL_NAME,
  PAGE_DELETER_MODAL_NAME,
  PAGE_REDIRECTOR_MODAL_NAME,
  ROUTE_DELETER_MODAL_NAME,
  TEMPLATE_DETAILS_MODAL_NAME,
  EXPORT_SITE_MODAL_NAME,
  SITE_PREVIEW_COLLABORATION_MODAL_NAME
];
